import { useQuery } from "@tanstack/react-query"
import { supportQuestionsQuery } from "../lib/supportQuestionsQuery"

export function useSupportQuestionsQuery(...args: Parameters<typeof supportQuestionsQuery>) {
  return useQuery(supportQuestionsQuery(...args))
}
